module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "epub:type": "dedication",
      "id": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("For Drew")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("Grief is just love with nowhere to go…")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/matrg-dedication.jpg"
    }
  })])]), _vm._v(" "), _c('blockquote', {
    staticClass: "written-note block-height-not-mult-of-line-height"
  }, [_c('div', {
    staticClass: "written-note-group written-note-alignment-center-group"
  }, [_c('p', {
    staticClass: "written-note-content written-note-alignment-center-content dedication-content"
  }, [_vm._v("Drew Peter George Cockton")]), _vm._v(" "), _c('p', {
    staticClass: "written-note-content written-note-alignment-center-content dedication-content"
  }, [_vm._v("1986-2022")])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/matrg---dedication.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 72
// module chunks = 0